import { getService } from 'data/function';
import { InviteMemberModalController } from '../inviteMemberModal/InviteMemberModalController';
import { AgentModalController } from '../agentModal/AgentController';
import InviteMemberModalView from '../inviteMemberModal/InviteMemberModalView.html';
import AgentModalView from '../agentModal/AgentModalView.html';
import { CallsTermsModalController } from '../callsTermsModal/CallsTermsModalController';
import CallsTermsModalView from '../callsTermsModal/CallsTermsModalView.html';
const modalTemplates = {
    'CallsTermsModal': {
        template: CallsTermsModalView,
        controller: CallsTermsModalController,
        controllerAs: '$ctrl',
    },
    'InviteModal': {
        template: InviteMemberModalView,
        controller: InviteMemberModalController,
        controllerAs: '$ctrl',
    },
    'InviteAgentModal': {
        template: AgentModalView,
        controller: AgentModalController,
        controllerAs: '$ctrl',
    },
};
export class ModalProcessor {
    static get ModalService() {
        return getService('ModalService');
    }
    static async process({ message, trackingProperties, source }) {
        try {
            const { template } = message.content;
            const modal = await ModalProcessor.ModalService.showModal(modalTemplates[template]);
            const modalResponse = await modal.close;
            const messageResponse = {
                response: modalResponse,
                trackingProperties,
            };
            source.postMessage(messageResponse, '*');
        }
        catch (e) {
            const errorResponse = {
                error: e.toString(),
                trackingProperties,
            };
            source.postMessage(errorResponse, '*');
        }
    }
}
